var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41799 6.32391C7.59544 5.12701 9.04939 4.38841 10.5702 4.1052L10.1908 2C8.26318 2.35897 6.41836 3.29678 4.92921 4.81053C1.0236 8.78064 1.0236 15.2175 4.92921 19.1876L3.13208 21.0144H8.21511V15.8474L6.41799 17.6742C3.33462 14.5399 3.33462 9.4582 6.41799 6.32391ZM20.8679 2.98563H15.7849V8.1526L17.582 6.3258C20.6654 9.4601 20.6654 14.5418 17.582 17.6761C16.4046 18.873 14.9506 19.6116 13.4298 19.8948L13.8092 22C15.7368 21.641 17.5816 20.7032 19.0708 19.1895C22.9764 15.2194 22.9764 8.78254 19.0708 4.81243L20.8679 2.98563Z",
    fill: "#2D3043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.f88831faf657e0c414e7a55f7e99f2a2.svg";
export { ForwardRef as ReactComponent };